<template>
  <form class="orders-filter" :class="{ open }">
    <div class="filters">
      <label>
        <p class="label-text">Ordem:</p>
        <input type="text" />
      </label>
      <label>
        <p class="label-text">Produto:</p>
        <input type="text" />
      </label>
      <label>
        <p class="label-text">Vencimento:</p>
        <DatePicker
          locale="pt-BR"
          v-model="selectedDate"
          mode="range"
          :popover="{ placement: 'bottom', visibility: 'hover' }"
        >
          <input type="text" :value="dateFormat" readonly />
        </DatePicker>
      </label>
    </div>
    <div class="buttons">
      <FilterBtn @click.prevent.native="handleSubmit">Aplicar</FilterBtn>
      <FilterBtn cancel @click.prevent.native="handleExpansion">Cancelar</FilterBtn>
    </div>
  </form>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import FilterBtn from "./FilterBtn";

export default {
  name: "OrdersFilter",
  props: {
    open: Boolean,
    handleExpansion: Function
  },
  data: () => ({
    selectedDate: String
  }),
  updated() {
    if (!this.open) {
      this.selectedDate = "";
    }
  },
  components: {
    DatePicker,
    FilterBtn
  },
  methods: {
    handleSubmit() {
      /* Fazer o submit e depois fechar */
      this.handleExpansion();
    }
  },
  computed: {
    dateFormat() {
      if (!this.selectedDate.start) return "";
      const initial = this.selectedDate.start.toLocaleDateString();
      const end = this.selectedDate.end.toLocaleDateString();
      return initial === end ? initial : initial + " - " + end;
    }
  }
};
</script>

<style scoped>
.orders-filter {
  height: 0;
  transition: height 0.7s, opacity 0.7s, visibility 0.7s;
  opacity: 0;
  visibility: hidden;
  position: relative;
  padding: 0 1rem;
}
.open.orders-filter {
  height: 10rem;
  opacity: 1;
  visibility: initial;
}

.filters {
  display: flex;
  align-items: flex-start;
  padding: 1rem 0 0.5rem;
}

.buttons {
  display: flex;
  justify-content: flex-start;
  margin-top: 1rem;
}

.label-text {
  margin: 0 0 0.4rem 0rem;
}

input {
  padding: 0.4rem 1rem;
  border: none;
  outline: 0;
  border-radius: 0.2rem;
  transition: all 0.3s;
  font-size: 1rem;
  box-shadow: 0 0 0 1px #42a5f5;
  margin-right: 1.8rem;
}
input:focus {
  background-color: var(--color-white);
  box-shadow: 0 0 1px 2px #42a5f5;
}
</style>
